export function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return [
    ...(container.querySelectorAll(
      [
        'input:not(:disabled):not([type="hidden"])',
        'button:not(:disabled)',
        'textarea:not(:disabled)',
        'select:not(:disabled)',
        'a[href]',
        '[tabindex]:not([tabindex="-1"])',
      ].join(', '),
    ) as NodeListOf<HTMLElement>),
  ];
}

export class FocusGuard {
  private container: HTMLElement;
  private focusableElements: HTMLElement[];
  private beforeGuard: HTMLElement = document.createElement('span');
  private afterGuard: HTMLElement = document.createElement('span');

  constructor(containerEl: HTMLElement) {
    this.container = containerEl;
    this.focusableElements = getFocusableElements(this.container);

    this.beforeGuard.addEventListener('focus', this.focusLast);
    this.beforeGuard.setAttribute('aria-hidden', 'true');

    this.afterGuard.addEventListener('focus', this.focusFirst);
    this.afterGuard.setAttribute('aria-hidden', 'true');

    this.container.prepend(this.beforeGuard);
    this.container.append(this.afterGuard);

    this.enable();
  }

  private focusFirst = () => {
    this.focusableElements[0]?.focus();
  };

  private focusLast = () => {
    this.focusableElements[this.focusableElements.length - 1]?.focus();
  };

  public enable = () => {
    this.beforeGuard.setAttribute('tabindex', '0');
    this.afterGuard.setAttribute('tabindex', '0');
  };

  public disable = () => {
    this.beforeGuard.setAttribute('tabindex', '-1');
    this.afterGuard.setAttribute('tabindex', '-1');
  };
}
